import React from 'react';
import Header from '../Header/Header';

const Deals = () => {
    return (
        <div>
            <Header></Header>
            <h1>This is Deals</h1>
        </div>
    );
};

export default Deals;